import * as React from 'react'

export const MarkerContent = (props) => {
    const onClick = (event) => {
        event.preventDefault()
        props.map.setZoom(18)
        props.map.setCenter(props.marker.getPosition())
    }

    return(
        <>
            {!props.dealer &&
                <>
                    <p>Uw start locatie:</p>
                    <p>{props.location}</p>
                    <a href='#' onClick={onClick}>Zoom hier</a>
                </>
            ||
                <>
                    <p className='address'>
                        <span>{props.dealer.name}</span>
                        <span>{props.dealer.address}</span>
                        <span>{props.dealer.zipcode} {props.dealer.place}</span>
                        <span>{props.dealer.zipcode}</span>
                    </p>
                    <p class="actions">
                        <DirectionsLink dealer={props.dealer} location={props.location} /><br />
                        <a href='#' onClick={onClick}>Zoom hier</a>
                    </p>
                </>
            }
        </>
    )
}

export const Result = (props) => (
    <>
        {props.dealers.length > 0 && props.dealers.map((dealer) => (
            <li>
                <p>
                    <strong>{dealer.name}</strong><br />
                    {dealer.address}<br />
                    {dealer.zipcode} {dealer.place}<br />
                    {dealer.country ?? 'Nederland'}<br />
                    <a href={`tel:${dealer.phone}`}>{dealer.phone}</a><br /><br />
                    {dealer.distance}<br />
                    <DirectionsLink dealer={dealer} location={props.location} />
                </p>
            </li>
        ))
        
        || <p>Geen resultaten gevonden, probeer de zoek afstand te vergroten.</p>}
    </>
)

const DirectionsLink = (props) => {
    const { address, zipcode, place, country } = props.dealer
    const location = props.location

    const url = `https://www.google.com/maps/dir/${location}/${address}%20${zipcode}%20${place},${country ?? 'Nederland'}`
    return (<a target='route' href={url}>Toon routebeschrijving</a>)
}